require('../bootstrap');

require('../plugins');

require('magnific-popup');

import * as Sentry from "@sentry/browser";

Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
});

$(document).ready(function () {
    // handle homepage boxes
    $('.ppn-boxes .ppn-box-hp').hover(function () {
        $('.ppn-boxes .ppn-box-hp').removeClass('active');
        $(this).toggleClass('active');

        let imgId = $(this).attr('data-target-img');

        $('.ppn-boxes .ppn-box-hp-img').addClass('d-none');
        $('#' + imgId).removeClass('d-none');
        $('#' + imgId).toggleClass('d-block');
    });

    // add automatic change of images
})

